import { render, staticRenderFns } from "./EventsByLocation.vue?vue&type=template&id=1b496a82&scoped=true&"
import script from "./EventsByLocation.vue?vue&type=script&lang=js&"
export * from "./EventsByLocation.vue?vue&type=script&lang=js&"
import style0 from "./EventsByLocation.vue?vue&type=style&index=0&id=1b496a82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b496a82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VScaleTransition } from 'vuetify/lib/components/transitions';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VBtn,VCard,VCardText,VContainer,VHover,VIcon,VScaleTransition,VTimeline,VTimelineItem})
